import React from 'react';
import BillLines from '../BillLines';
import { canEditServices } from '../../../utils/billSteps';

/** Step 3 — the saved bill, before payment. */
export default function BillStep({ bill, onEdit }) {
  return (
    <div className="dp-step-body">
      <div className="dp-step-head dp-step-head--row">
        <div>
          <h2>Created bill</h2>
          <p className="dp-help">
            Bill for <strong>{bill.customer?.name || 'guest'}</strong> at <strong>{bill.franchise_name || 'this branch'}</strong>. Check it, then
            take payment.
          </p>
        </div>
        {canEditServices(bill) ? (
          <button type="button" className="dp-btn dp-btn--ghost" onClick={onEdit}>
            Edit services
          </button>
        ) : null}
      </div>
      <BillLines bill={bill} />
    </div>
  );
}
